<script>
  import { onMount } from "svelte";
  import {External, M} from "../external";
  import { ignore } from './tools';

  export let onChange = ignore, value, instance, readonly = false;

  onMount(function () {
    let jq = External.$(instance);

    let datePicker = jq.datetimepicker({
      minDate: new Date(),
      dateFormat: External.WebsiteSettings.getDateFormatPattern(),
      timeFormat: External.WebsiteSettings.getTimeFormatPattern(),
      onSelect: function () {
        value = datePicker.datetimepicker("getDate").getTime();
        onChange(value);
      },
      currentText: M.TIME_NOW,
      closeText: M.CLOSE,
      timeText: M.TIME,
      hourText: M.TIME_HOUR,
      minuteText: M.TIME_MINUTE,
      secondText: M.SECONDS
    });

    datePicker.datetimepicker("setDate", new Date(value));
  });
</script>

<input type="text" name="datePicker" placeholder="Select date" bind:this={instance} {readonly} />
